import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { InvoiceableType } from '../../constants/transaction';
import { HierarchicalStructure, NodeStructure, ReceiptCancel, ShieldSecurity, Tag } from '../icons';
import { Button } from '../Ant';

export interface IMatterIndicatorsProperties {
  invoiceableType: InvoiceableType;
  hasSubMatters?: boolean;
  parentMatterId?: string;
  fixedPriceInUse?: boolean;
  insider?: boolean;
  currency?: string;
  fixedPrice?: number;
}

export const MatterIndicators = ({
  invoiceableType,
  hasSubMatters,
  parentMatterId,
  fixedPriceInUse,
  insider,
  currency = 'EUR',
  fixedPrice = 0,
}: IMatterIndicatorsProperties) => {
  const { t } = useTranslation();

  const isNonBillable = invoiceableType === InvoiceableType.NON_BILLABLE;
  const isParent = Boolean(hasSubMatters);
  const isSub = Boolean(parentMatterId);

  return (
    <>
      {isParent && (
        <Tooltip title={t('matter:indicators.parentMatter')} placement="top" arrow={false}>
          <Button
            aria-label={t('matter:indicators.parentMatter')}
            data-testid="parent-matter-button"
            className="important-note-btn"
            icon={<NodeStructure className="fz-16" />}
          />
        </Tooltip>
      )}
      {!isParent && isSub && (
        <Tooltip title={t('matter:indicators.subMatter')} placement="top" arrow={false}>
          <Button
            aria-label={t('matter:indicators.subMatter')}
            data-testid="sub-matter-button"
            className="important-note-btn"
            icon={<HierarchicalStructure className="fz-16" />}
          />
        </Tooltip>
      )}
      {fixedPriceInUse && (
        <Tooltip
          title={t('matter:indicators.fixedFee', { amount: fixedPrice ?? 0, currency })}
          placement="top"
          arrow={false}
        >
          <Button
            aria-label={t('matter:indicators.fixedFee', { amount: fixedPrice ?? 0, currency })}
            data-testid="fixed-matter-button"
            className="important-note-btn"
            icon={<Tag className="fz-16" />}
          />
        </Tooltip>
      )}
      {isNonBillable && (
        <Tooltip title={t('matter:indicators.nonBillable')} placement="top" arrow={false}>
          <Button
            aria-label={t('matter:indicators.nonBillable')}
            data-testid="non-billable-matter-button"
            className="important-note-btn"
            icon={<ReceiptCancel className="fz-16" />}
          />
        </Tooltip>
      )}
      {insider && (
        <Tooltip title={t('matter:indicators.insider')} placement="top" arrow={false}>
          <Button
            aria-label={t('matter:indicators.insider')}
            data-testid="insider-button"
            className="important-note-btn"
            icon={<ShieldSecurity className="fz-16 text-clr-yellow-300" />}
          />
        </Tooltip>
      )}
    </>
  );
};
